import {GoingUtils} from "goingutils";


export default {
    name: 'drop-mixins',
    data() {
        return {
            suffixString:"",
            timeout:null,
            inputHeight:32,
            showFlag:false,//显示标志
        };
    },
    computed: {
        //根据下拉的显示与隐藏 来显示不同的图标
        dropSuffixIcon(){
            if (this.showFlag) {
                return 'ivu-icon ivu-icon-ios-arrow-up';
            } else {
                return 'ivu-icon ivu-icon-ios-arrow-down';
            }
        }
    },
    props: {},
    methods: {
        //获取弹出框的高度
        getDropHeight() {
            let {winHeight = this.winDropHeight} = this.item;
            return parseInt(winHeight) - 4;
        },
        //获取弹出框的宽度
        getDropWidth() {
            let {winWidth = this.winDropHeight} = this.item;
            return parseInt(winWidth) - 4;
        },
        inputClick(inputEl) {
            this.showPageDrop(inputEl);
        },
        //点击界面其他地方 关闭下拉
        addDocEvent() {
            let vueObj = this;
            let suffixString=this.suffixString;
            //如果点击不是该控件范围只内 则隐藏该控件下拉
            $(document).click(function (e) {
                let target = $(e.target);
                if (
                    !target.is("#" + vueObj.inputId + " _container") &&
                    !target.is("#" + vueObj.inputId + " _container .go-content *") &&
                    !target.is("#" + vueObj.inputId + suffixString) &&
                    !target.is("#" + vueObj.inputId + suffixString+" *")
                ) {
                    vueObj.showFlag=false;
                    //隐藏下拉
                    $(`#${vueObj.inputId}${suffixString}`).hide();
                }
            });
            if(vueObj.documentBody){
                //注册滚动事件
                if($(`#${vueObj.inputId}_container`).get(0)!=null){
                    $(`#${vueObj.inputId}_container`).closest(".go_win_obj").scroll(function () {
                        vueObj.setElDropPos(false);
                    });
                }
            }
        },
        setElDropPos(shoFlag,backFun){
            let suffixString=this.suffixString;
            if(this.timeout!=null){
                clearTimeout(this.timeout);
            }

            let _inputId = this.inputId;
            this.timeout=setTimeout(()=>{
                let inputPos = GoingUtils.getElementPosition($(document.getElementById(this.inputId + "_inputDiv")).find(`input`).get(0));
                let curHeight=inputPos.y+this.winDropHeight;
                //如果高度超过了屏幕高度 则向上显示
                if(curHeight>$(document.body).height()-80){
                    $(`#${_inputId}${suffixString}`).css("left", inputPos.x).css("top", inputPos.y- 32 -this.winDropHeight).css("zIndex", GoingUtils.getCurMaxZIndex());
                }else{
                    //没有超过 则向下显示
                    $(`#${_inputId}${suffixString}`).css("left", inputPos.x).css("top", inputPos.y+ 32).css("zIndex", GoingUtils.getCurMaxZIndex());
                }
                if(shoFlag){
                    // $(`#${_inputId}${suffixString}`).show();
                }
                if(backFun!=null){
                    backFun();
                }
            },10);
        },
        //显示下拉选项信息
        showPageDrop($event, item) {
            if (item.disabled) {
                return void (0);
            }
            this.toggleDrapShow($event);
        },
    },
    mounted() {
    },
    components: {},
    watch:{
        showFlag(newVal){
            let _inputId = this.inputId;
            let suffixString=this.suffixString;
            if(newVal){
                $(`#${_inputId}${suffixString}`).show();
            }else{
                $(`#${_inputId}${suffixString}`).hide();
            }
        }
    },
};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/formVue/mixins/dropDownMixin.js